import { IdentityPlatform } from '@playcastdotio/CoreTypes';
import { md5 } from 'js-md5';

const createHashedUsername = (authId: string): string => {
  // Create a hash of the authId and ensure it only uses lowercase alphanumeric characters
  return md5(authId).toLowerCase();
};

const platformToSlug = (platform: IdentityPlatform) => {
  switch (platform) {
    case IdentityPlatform.CLERK:
      return 'p';
    case IdentityPlatform.DISCORD:
      return 'pd';
    case IdentityPlatform.TWITCH:
      return 'pt';
    default:
      return 'p';
  }
};

/**
 * Determine the platform based on aliases
 * @param aliases - Object containing aliases for different platforms
 * @returns The determined platform or undefined if none found
 */
export const determinePlatformFromAliases = (aliases: Record<string, string>): IdentityPlatform | undefined => {
  if (aliases && Object.keys(aliases).length > 0) {
    // If we have a default alias, find the platform that matches it
    if (aliases.default) {
      const defaultAlias = aliases.default;
      // Find the platform key that has the same value as the default alias
      const platform = Object.entries(aliases).find(([key, value]) => key !== 'default' && value === defaultAlias)?.[0] as
        | IdentityPlatform
        | undefined;

      if (platform) {
        return platform;
      }
    }

    // Fallback: return the first platform that isn't 'default'
    const platform = Object.keys(aliases).find((key) => key !== 'default') as IdentityPlatform;

    return platform;
  }
  return undefined;
};

type Props = {
  authId?: string;
  username?: string;
  defaultAlias?: string;
  platform?: IdentityPlatform;
};

export const determineProfileSlug = ({ authId, username, defaultAlias, platform }: Props) => {
  if (defaultAlias && platform) {
    return `${platformToSlug(platform)}/${defaultAlias}`;
  }
  if (username) {
    return `p/${username}`;
  }
  if (authId) {
    const hashedUsername = createHashedUsername(authId);
    return `p/${hashedUsername}`;
  }
  console.error('No profile slug found');
  return;
};
